import { render, staticRenderFns } from "./breadMenu.vue?vue&type=template&id=1b3aa6b0&scoped=true"
import script from "./breadMenu.vue?vue&type=script&lang=js"
export * from "./breadMenu.vue?vue&type=script&lang=js"
import style0 from "./breadMenu.vue?vue&type=style&index=0&id=1b3aa6b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3aa6b0",
  null
  
)

export default component.exports